export default __webpack_public_path__ + "static/media/plus.a3d9c9ef.svg";